export const sumPercentWidths = (...widths: string[]): string => {
  const widthInts = widths.map((width) => parseInt(width.match(/\d+/)?.join('') ?? '0'));
  return `${widthInts.reduce((acc, int) => acc + int, 0)}%`;
};
